import axios from 'axios/index'
import store from '../../store.js'

export default {
  install (vue, opts) {
    vue.apiUrl = (uri) => process.env.VUE_APP_API_URL.replace(/\/$/, '') + '/api/' + String(uri).replace(/^\//, '')
    vue.apiGet = (uri, data, options) => vue.apiRequest('GET', uri, data, options)
    vue.apiPost = (uri, data, options) => vue.apiRequest('POST', uri, data, options)
    vue.apiPut = (uri, data, options) => vue.apiRequest('PUT', uri, data, options)
    vue.apiPatch = (uri, data, options) => vue.apiRequest('PATCH', uri, data, options)
    vue.apiDelete = (uri, data, options) => vue.apiRequest('DELETE', uri, data, options)

    vue.api = {
      url: uri => vue.apiUrl(uri),
      get: (uri, data, options) => vue.apiRequest('GET', uri, data, options),
      post: (uri, data, options) => vue.apiRequest('POST', uri, data, options),
      put: (uri, data, options) => vue.apiRequest('PUT', uri, data, options),
      patch: (uri, data, options) => vue.apiRequest('PATCH', uri, data, options),
      delete: (uri, data, options) => vue.apiRequest('DELETE', uri, data, options)
    }

    vue.$api = vue.api

    vue.$env = {
      get () {
        return process.env.VUE_APP_ENVIRONMENT
      }
    }

    vue.$ui = {
      setTitle: title => document.title = title + ' - AnnoAnno',
      message: message => {
        store.commit('setInterfaceMessage', {
          message: message,
          type: 'info'
        })

        setTimeout(() => store.commit('setInterfaceMessage', {}), 5000)
      }
    }

    vue.$array = {
      keyValue (array, key, value) {
        var list = {}

        for (var i in array) {
          list[array[i][key]] = array[i][value]
        }

        return list
      }
    }

    vue.$website = {}

    vue.$user = {
      hasRole: role => store.getters.getStylistUserRoles.indexOf(role) >= 0
    }

    /**
         * [description]
         * @param  {[type]} method [description]
         * @param  {[type]} uri    [description]
         * @param  {[type]} data   [description]
         * @return {[type]}        [description]
         */
    vue.apiRequest = (method, uri, data, options) => {
      options = vue.buildOptions(options)

      options.before()
      // console.log(options.loader);
      if (typeof options.loader !== 'undefined') {
        options.loader(true)
      }
      // console.log(options.loader);
      return axios({
        url: vue.apiUrl(uri),
        data: data,
        method: method,
        headers: vue.buildHeaders(options),
        onDownloadProgress: (data, b, c) => {
          if (options.onProgress) {
            options.onProgress(data)
          }
        }
      }).then(response => {
        if (typeof options.loader !== 'undefined') {
          options.loader(false)
        }
        if (typeof response.data.error !== 'undefined') {
          options.errorMessage(response.data.message)
          options.error()
          options.always()
        } else {
          options.always()
          return options.callback(response.data)
        }
        return null
      }).catch(e => {
        if (typeof options.loader !== 'undefined') {
          options.loader(false)
        }

        const response = e.response.data
        if (response.message === 'Unauthorized' || response.exception === 'AuthenticationException') {
          store.commit('setToken', '')
          store.commit('setStylist', {})
        }

        console.log(e, e.response)
        options.errorMessage(e.response.data.message)
        options.error(e.response)
        options.always()
      })
    }

    /**
         * [description]
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
    vue.buildOptions = (options) => {
      if (typeof options === 'undefined') {
        options = {}
      }

      var functions = ['before', 'callback', 'error', 'always']
      for (var i in functions) {
        var name = functions[i]
        if (typeof options[name] === 'undefined') {
          options[name] = function () {}
        }
      }

      if (!options.errorMessage) {
        options.errorMessage = function (message) {
          alert(message)
          console.error('API error: ', message)
        }
      }

      return options
    }

    /**
         * [description]
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
    vue.buildHeaders = (options) => {
      var header = {}

      if (typeof options.headers !== 'undefined') {
        header = options.headers
      }

      // if (typeof options.authentication != 'undefined' && options.authentication) {
      if (store.getters.getToken) {
        header.Authorization = 'Stylist ' + store.getters.getToken
      } else {
        header.Authorization = '87324876234jjhds76783jhjhds7878132'
      }

      return header
    }

    vue.$create = {
      dateTime (value) {
        if (value) {
          switch (typeof value) {
            case 'object':
              this.value = value
              break
            case 'string':
              this.value = new Date(value)
              break
            default:
              console.error('Cannot parse dateTime value: ' + (typeof value))
          }
        } else {
          this.value = new Date()
        }

        this.addHours = function (hours) {
          this.value = new Date(this.value.getTime() + hours * 60 * 60 * 1000)

          return this
        }

        this.addDays = function (days) {
          this.value = new Date(this.value.getTime() + 24 * 60 * 60 * 1000)

          return this
        }

        this.format = function (format) {
          var d = this.value.getDate()
          var m = this.value.getMonth() + 1
          var H = this.value.getHours()
          var i = this.value.getMinutes()
          var s = this.value.getSeconds()

          var replace = {
            d: d < 10 ? '0' + d : d,
            m: m < 10 ? '0' + m : m,
            Y: this.value.getFullYear(),
            H: H < 10 ? '0' + H : H,
            i: i < 10 ? '0' + i : i,
            s: s < 10 ? '0' + s : s
          }

          var output = format

          for (var key in replace) {
            output = output.replace(key, replace[key])
          }

          return output
        }

        vue.$create = {
          dateTime (value) {
            if (value) {
              switch (typeof value) {
                case 'object':
                  this.value = value
                  break
                case 'string':
                  this.value = new Date(value)
                  break
                default:
                  console.error('Cannot parse dateTime value: ' + (typeof value))
              }
            } else {
              this.value = new Date()
            }

            this.addDays = function (days) {
              this.value = new Date(this.value.getTime() + days * 24 * 60 * 60 * 1000)

              return this
            }

            this.format = function (format) {
              var d = this.value.getDate()
              var m = this.value.getMonth() + 1
              var H = this.value.getHours()
              var i = this.value.getMinutes()
              var s = this.value.getSeconds()

              var replace = {
                d: d < 10 ? '0' + d : d,
                m: m < 10 ? '0' + m : m,
                Y: this.value.getFullYear(),
                H: H < 10 ? '0' + H : H,
                i: i < 10 ? '0' + i : i,
                s: s < 10 ? '0' + s : s
              }

              var output = format

              for (var key in replace) {
                output = output.replace(key, replace[key])
              }

              return output
            }

            return this
          }
        }

        return this
      }
    }
  }
}
